<template>
    <div>
        <div v-if="! errorPage">
            <!-- this is the header -->
            <Header 
                :menus="menus"
                :params="params"
                :isLoadingBlade="isLoadingBlade"
            />
            <!-- end:header-top -->
            

            <PageTemplate
                :record="page.record"
                :category="page.category"
                :service="services"
                :params="params"
                v-if="page.record && ! isLoadingBlade"
            />


            <!-- Footer included here -->
            <Footer 
                :params="params"
                :services="services"
                v-if="! isLoadingBlade"
            />
        </div>

        <ErrorPage 
            v-if="! isLoadingBlade && errorPage"
        />
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Header from '../layouts/Header.vue'
    import Footer from '../layouts/Footer.vue'
    import PageTemplate from '../layouts/PageTemplate.vue'
    import ErrorPage from './ErrorPage.vue';

    export default {
        name: 'OtherContentPage',
        components: {
            Header,
            Footer,
            PageTemplate,
            ErrorPage
        },
        data() {
            return {
                isLoadingBlade: true,
                errorPage: false,
                errorMsg: '',
                menus: [],
                params: {},
                services: [],
                page: {}
            }
        },
        computed: {
            ...mapGetters(['getsiteName', 'amadeusUrl']),
            getSearchUrl() {
                let path = this.$route.fullPath;
                let splitted = path.split('?');
                let url = splitted && splitted.length ? splitted[1] : false
                return url ? (this.amadeusUrl + url) : false
            }
        },
        methods: {
            ...mapActions(['getOtherContentPage']),
            loadPage() {
                this.errorPage = false;
                let data = { 
                    'category' : this.$route.params.category,
                    'slug' : this.$route.params.slug,
                }
                this.getOtherContentPage(data).then((res) => {// get homepage data
                    if(res.status == 200) { // set data
                        this.setData(res.data);
                    } else {
                        this.isLoadingBlade = false;
                        this.errorPage = true
                        this.errorMsg = 'Page was not able to load, reload page...'
                    }
                }).
                catch(() => {
                    this.isLoadingBlade = false;
                    this.errorPage = true
                    this.errorMsg = 'Page was not able to load, reload page...'
                });
            },
            setData(data) {
                this.menus = data.menus;// update menus
                this.params = data.parameters;// set parameters
                this.services = data.services; // set service contents
                this.page = data.page;// get page content
                setTimeout(() => { this.isLoadingBlade = false; }, 1000)
            }
        },
        created() {
            this.loadPage(); // get page contents
        }
    }
</script>

<style lang="scss" scoped>

</style>